import {IAlertModal, IAdmin, IUser, IInfoResponse, IAdvResponse} from "@data";
import {atom} from "recoil";
import stateKeys from "./stateKeys";
import {ScreenId} from "@assets";

const states = {
  alertState: atom<IAlertModal>({
    key: stateKeys.alertModalKey,
    default: {},
  }),
  adminDataState: atom<IAdmin | undefined>({
    key: stateKeys.adminDataKey,
    default: undefined,
  }),
  userDataState: atom<IUser | undefined>({
    key: stateKeys.userDataKey,
    default: undefined,
  }),
  loadingState: atom<boolean>({
    key: stateKeys.loadingKey,
    default: false,
  }),
  pathState: atom<ScreenId>({
    key: stateKeys.pathKey,
    default: undefined,
  }),
  infoDataState: atom<IInfoResponse[]>({
    key: stateKeys.infoDataKey,
    default: [],
  }),
  advDataState: atom<IAdvResponse[]>({
    key: stateKeys.advDataKey,
    default: [],
  }),
  memberSequnceState: atom<number | undefined>({
    key: stateKeys.memberSequnceKey,
    default: undefined,
  }),
};

export default states;
